import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import CategoriesBtnData from "../../js/categoriesBtnData";
import categoriesBtnSecData from "../../js/categoriesBtnSecData";
import Img from "../../assets/image/index";
import Icons from "../../assets/icon/index";
import {
  Animatespin,
  HeadingCom,
  CategoriesBtnCom,
} from "../../components/index";
import localimgpath from "../../js/localimgpath";
import Functions from "./index.function";
const Categories = () => {
  const { isLoading, swiperRef, maincategory, handlemaincategory } =
    Functions();
  return (
    <div className="bg-primary lg:px-5 xl:px-10 xs:px-3 sm:px-5 lg:mt-5">
      <div className=" xs:py-6 sm:py-8 lg:py-10">
        <HeadingCom title={"Categories"} to={"/category-detail"} />
      </div>
      {isLoading ? (
        <Animatespin />
      ) : (
        <div
          className="w-full home-catedory-slider"
          onMouseEnter={() => swiperRef.current?.autoplay?.start()}
          onMouseLeave={() => swiperRef.current?.autoplay?.stop()}
        >
          <Swiper
            modules={[Autoplay]}
            spaceBetween={20}
            loop={maincategory?.categories?.length > 6} // Only loop if more than 6 items
            loopAdditionalSlides={3}
            slidesPerGroup={1}
            autoplay={{ 
              delay: 2000, 
              disableOnInteraction: false,
              pauseOnMouseEnter: true 
            }}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            centeredSlides={false}
            watchSlidesProgress={true}
            breakpoints={{
              320: { 
                slidesPerView: 2,
                spaceBetween: 10,
              },
              768: { 
                slidesPerView: 3,
                spaceBetween: 15,
              },
              1024: { 
                slidesPerView: maincategory?.categories?.length >= 4 ? 4 : maincategory?.categories?.length,
                spaceBetween: 20,
              },
              1200: { 
                slidesPerView: maincategory?.categories?.length >= 5 ? 5 : maincategory?.categories?.length,
                spaceBetween: 20,
              },
              1400: { 
                slidesPerView: maincategory?.categories?.length >= 5 ? 5 : maincategory?.categories?.length,
                spaceBetween: 20,
              },
              1600: { 
                slidesPerView: maincategory?.categories?.length >= 6 ? 6 : maincategory?.categories?.length,
                spaceBetween: 20,
              },
            }}
          >
            {maincategory?.categories?.map((value, index) => (
              <SwiperSlide key={index} className="flex">
                <CategoriesBtnCom
                  onClick={() => handlemaincategory(value.id)}
                  btnTitle={value.title}
                  bgColor={
                    CategoriesBtnData[index % CategoriesBtnData.length].bgColor
                  }
                  btnIcon={
                    value?.icon
                      ? `${localimgpath?.categoryIcons}/${value?.icon}`
                      : Icons.directorChairIcon
                  }
                  CateclassName={
                    "cursor-pointer mb-3 xs:w-full sm:w-full lg:w-full 3xl:w-full 2xl:w-full xs:h-12 sm:h-14 lg:h-16 sm:gap-2 xs:gap-1 lg:gap-2 rounded-lg sm:rounded-xl relative flex items-center justify-center overflow-hidden text-secondary transition-all shadow-md before:absolute before:h-0 before:w-0 before:rounded-full before:bg-orange-600 hover:shadow-orange-600 before:duration-500 before:ease-out hover:before:h-56 hover:before:w-[120%]"
                  }
                  fontClassname={
                    "font-onestSemiBold uppercase text-[10px] sm:text-sm lg:text-base"
                  }
                  iconlayout={"xs:w-4 sm:w-5 lg:w-6"}
                  alt={value.title}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
      <div
        className="relative xs:flex xs:flex-col mx-auto bg-cover xs:bg-center xs:rounded-3xl sm:rounded-[70px] lg:rounded-[80px] sm:my-14 xl:mt-40 xl:mb-28 lg:mt-28 3xl:mt-44 flex items-center px-5 sm:px-12 3xl:py-24 pt-6 sm:py-16 my-6"
        style={{ backgroundImage: `url(${Img.CategoriesBannerImg})` }}
      >
        <div className="lg:w-2/4">
          <div className="lg:w-full sm:w-72">
            <h3 className="text-secondary font-unboundedBold lg:text-4xl uppercase">
              Our Mission
            </h3>
            <p className="font-onestRegular text-secondary xs:py-1 sm:py-1 xl:py-3 lg:py-2 text-lg leading-6">
              Gem's Mission Is To Expand Its Organization And Become a Global
              Community Of Gems From Various Parts Of The World, While All Of Us
              Are Connected To One Root i.e. Gem As Stakeholders And Owners Of
              The Company.
            </p>
          </div>
          <div className="lg:w-full sm:w-72">
            <h3 className="text-secondary font-unboundedBold uppercase lg:text-4xl">
              UNITING GEMS
            </h3>
            <div className="bg-[#FA5738] w-fit rounded-full px-2 py-1 my-1 sm:my-2 lg:my-2.5">
              <h4 className="text-secondary font-unboundedBold lg:text-2xl">
                10,000,00
              </h4>
            </div>
            <p className="font-onestRegular text-secondary xl:mb-2 lg:mb-1 text-lg leading-6 xs:py-1">
              Our Goal Is To Unite 10 Million Gems Like You Globally As
              Stakeholders Of The Company By 2030.
            </p>
            <div className="bg-[#2F54CC] w-fit rounded-full px-2 mt-1 sm:my-1 sm:mt-3 lg:mt-5 pt-1">
              <h4 className="text-secondary font-josefinSansMedium text-lg">
                #IAMGEMGLOBAL
              </h4>
            </div>
          </div>
        </div>
        <div className="xs:hidden lg:w-[95%] xl:w-5/6 2xl-wide:w-9/12 3xl:w-9/12 absolute bottom-0 right-0 xs:rounded-3xl sm:rounded-[70px] lg:rounded-[80px] overflow-hidden">
          <img src={Img.ourMissionImg} className="" alt="ourMissionImg" />
        </div>
        <div className="flex sm:hidden justify-center items-center w-full pt-6">
          <img
            src={Img.ourMissionmMobileImg}
            className="w-10/12"
            alt="ourMissionmMobileImg"
          />
        </div>
      </div>
      <div className="">
        <div className="flex justify-center items-center xs:mb-5 sm:mb-6 lg:mb-10">
          <h3 className="text-secondary font-unboundedBold xs:text-center text-lg sm:text-2xl lg:text-4xl rotate- uppercase">
            WHAT YOU CAN DO ON GEM?
          </h3>
        </div>
        <div className="grid xs:grid-cols-2 sm:grid-cols-3 sm:gap-y-4 gap-x-3 gap-y-2.5 sm:gap-x-5 lg:gap-y-8 lg:gap-x-12 max-w-[1500px] mx-auto lg:py-5">
          {categoriesBtnSecData.map((value, index) => (
            <div key={index}>
              <CategoriesBtnCom
                btnTitle={value.BtnTitle}
                bgColor={"#202020"}
                btnIcon={value.btnIcon}
                CateclassName={
                  "cursor-pointer sm:gap-x-2 lg:gap-x-3 gap-x-1.5 py-2 sm:py-3 lg:py-5 w-full rounded-full flex justify-center items-center before:ease relative overflow-hidden text-blue-500 shadow-md transition-all before:absolute before:top-1/2 before:h-0 before:w-full before:origin-center before:-translate-x-30 before:rotate-0 before:bg-blue-500 before:duration-300 hover:text-white hover:shadow-blue-500 hover:before:h-96 hover:before:-translate-y-32"
                }
                fontClassname={
                  "font-onestBold xs:!text-[10px] sm:text-sm lg:text-lg xl:text-2xl"
                }
                btnIconlayout={
                  "xs:!w-4 sm:w-6 sm:h-6 lg:w-8 xl:w-12 lg:h-8 xl:h-12"
                }
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Categories;
